export default "__VITE_ASSET__Gv1cQVCd__"